<script lang="ts">
  interface Props {
    onSend: (content: string) => void;
    disabled?: boolean;
    placeholder?: string;
  }

  let { onSend, disabled = false, placeholder = '메시지를 입력하세요...' }: Props = $props();

  let content = $state('');
  let textareaEl: HTMLTextAreaElement;

  function handleSubmit(e: Event) {
    e.preventDefault();
    if (content.trim() && !disabled) {
      onSend(content.trim());
      content = '';
      resetHeight();
    }
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  }

  function handleInput() {
    // Auto-resize textarea
    if (textareaEl) {
      textareaEl.style.height = 'auto';
      textareaEl.style.height = `${Math.min(textareaEl.scrollHeight, 120)}px`;
    }
  }

  function resetHeight() {
    if (textareaEl) {
      textareaEl.style.height = 'auto';
    }
  }
</script>

<form onsubmit={handleSubmit} class="p-4 border-t border-default bg-surface">
  <div class="flex items-end gap-2">
    <div class="flex-1 relative">
      <textarea
        bind:this={textareaEl}
        bind:value={content}
        oninput={handleInput}
        onkeydown={handleKeyDown}
        {placeholder}
        rows="1"
        {disabled}
        class="w-full resize-none bg-surface-tertiary text-content rounded-xl px-4 py-3 pr-12
               min-h-12 max-h-[120px]
               focus:outline-none focus:ring-2 focus:ring-primary/40
               placeholder:text-gray-500 dark:placeholder:text-dark-text-low disabled:opacity-50
               scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-dark-border scrollbar-track-transparent"
      ></textarea>
    </div>

    <button
      type="submit"
      disabled={disabled || !content.trim()}
      aria-label="메시지 보내기"
      class="flex-shrink-0 w-12 h-12 rounded-full bg-primary text-white
             hover:bg-primary-light disabled:opacity-50 disabled:cursor-not-allowed
             transition-colors flex items-center justify-center"
    >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
      </svg>
    </button>
  </div>
</form>
